// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/dci.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../google/protobuf/timestamp";
import { DciType, dciTypeFromJSON, dciTypeToJSON } from "./fabric";
import { Annotation } from "./global";
import { BgpPeer } from "./routing";
import { Metadata, RouteInfo } from "./types";

export const protobufPackage = "models";

/** FabricVni describes a fabric L2VNI exported to multisite interconnect. */
export interface FabricVni {
  /** The identifier of linked fabric. */
  fabricId: string;
  /** The VNI of the fabric logical network. */
  vni: number;
  /** The name of the logical network (readonly). */
  name: string;
  /** Indicates that VNI is in enabled state. */
  enabled: boolean;
  /** The transit or normalized VNI. */
  normalizedVni: number;
}

/** FabricSvi describes a SVI of a VRF that needs to be mapped to the multisite interconnect. */
export interface FabricSvi {
  /** The VNI of the logical network. */
  vni: number;
  /** Indicates that SVI is in enabled state. */
  enabled: boolean;
  /** The transit or normalized VNI. */
  normalizedVni: number;
}

/** BgpPolicyLink maps BGP policies to remote fabrics. */
export interface BgpPolicyLink {
  /** The identifier of the linked fabric. */
  fabricId: string;
  /** VRF export policy identifier. Do not use; internal use only. */
  exportPolicyId: string;
  /** VRF import policy identifier. Do not use; internal use only. */
  importPolicyId: string;
}

/** FabricVrf describes a fabric VRF exported to multisite interconnect. */
export interface FabricVrf {
  /** The identifier of the fabric. */
  fabricId: string;
  /** The VRF name. */
  name: string;
  /** The L3VNI of the VRF (readonly). */
  vrfVni: number;
  /** Indicates that VRF is in enabled state. */
  enabled: boolean;
  /** The transit or normalized VNI. */
  normalizedVni: number;
  /** A list of VRF SVIs to be mapped. */
  svis: FabricSvi[];
  /** A list of BGP policies to be applied to the VRF. */
  policies: BgpPolicyLink[];
}

/** FabricLink describes a link to a fabric. */
export interface FabricLink {
  /** The identifier of the fabric. */
  fabricId: string;
  /** The name of the fabric. */
  name: string;
}

/** MultisiteSvi defines the VNI info to be used as SVI for multisite VRF. */
export interface MultisiteSvi {
  /** The VNI of the logical network. */
  vni: number;
  /** The name of the logical network. */
  name: string;
  /** Indicates that mapping is in enabled state. */
  enabled: boolean;
}

/** DciVni describes the DCI Vni mapping info. */
export interface DciVni {
  /** The transit or normalized VNI. */
  vni: number;
  /** The name of the DCI mapping. */
  name: string;
  /** The description of the VNI mapping. */
  description: string;
  /** Indicates that VNI mapping is in enabled state. */
  enabled: boolean;
  /** Indicates if VNI is for L3 (VRF) mapping. */
  isL3: boolean;
  /** Fabrics that are linked to this normalized VNI. */
  fabrics: FabricLink[];
  /** VRF SVI mappings. This field is valid only for L3 (VRF) normalized VNI. */
  svis: MultisiteSvi[];
  /** Fabric VNI mapped to normalized VNI (L2 mapping). Do not use; internal use only. */
  vnis: FabricVni[];
  /** Fabric VRF mapped to normalized VNI (L3 mapping). Do not use; internal use only. */
  vrfs: FabricVrf[];
}

/** DciPort describes a border port of a DCI node. */
export interface DciPort {
  /** The logical name of the border port (E.g. port1). */
  name: string;
  /** Indicates that port mapping is in enabled state. */
  enabled: boolean;
  /** Custom MTU for the port. Do not use; internal use only. */
  mtu: number;
  /** The IP address of the border port. Do not use; internal use only. */
  ipAddress: string;
}

/** DciNode describes a border gateway node of a fabric. */
export interface DciNode {
  /** The identifier of the node. */
  nodeId: string;
  /** The name of the node, */
  name: string;
  /** The description of the node. */
  description: string;
  /** Indicates that node is in enabled state. */
  enabled: boolean;
  /** The IP address of the unique VTEP (third VTEP). */
  primaryIp: string;
  /** The BGP source IP address or switch loopback IP. */
  loopbackIp: string;
  /** A list of ports to be used as border ports. Do not use; internal use only. */
  ports: DciPort[];
}

/** DciFabric describes a DCI member fabric config. */
export interface DciFabric {
  /** The identifier of the fabric; maybe empty for external fabric. */
  fabricId: string;
  /** The name of the DciFabric; may not be same as fabric name. */
  name: string;
  /** The description of DciFabric object. */
  description: string;
  /** Indicates that fabric is in enabled state. */
  enabled: boolean;
  /** The email address to be used for invitation notification. */
  email: string;
  /** The anycast VTEP IP. */
  virtualIp: string;
  /** The ASN to be used for BGP peering. */
  asn: number;
  /** The anycast IP for fabric VTEP. Do not use; internal use only. */
  fabricIp: string;
  /**
   * Rules:
   *  accepted = false and accepted_at = NIL means that invitation is pending.
   *  accepted = true and accepted_at = VALID means that invitation has been accepted.
   *  accepted = false and accepted_at = VALID means that invitation has been rejected.
   */
  accepted: boolean;
  /** The timestamp of accept or reject. */
  acceptedAt:
    | Date
    | undefined;
  /** The last fabric commit identifier. */
  commitId: string;
  /** A list of border nodes. */
  nodes: DciNode[];
}

/** DciConfig describes the configuration for datacenter interconnect. */
export interface DciConfig {
  /**
   * The unique identifier of DciConfig. Identifier is required to update an existing
   * DciConfig. If identifier is missing, then set operation defaults to CREATE mode.
   */
  id: string;
  /** The user-defined name of DciConfig. DciConfig name is unique, and is case-insensitive. */
  name: string;
  /** A user-defined description of DciConfig. Description can be up to 2000 characters. */
  description: string;
  /** A set of user-defined labels for searching and locating objects. */
  labels: string[];
  /** A set of annotations to store user-defined data. */
  annotations: Annotation[];
  /** Indicates if DciConfig is enabled or disabled. */
  enabled: boolean;
  /**
   * Readonly revision metadata of the object. Metadata is not required
   * for object creation or modification.
   */
  metadata:
    | Metadata
    | undefined;
  /** The revision identifier of committed config. This field is readonly. */
  candidateId: string;
  /** Type of datacenter interconnect. */
  type: DciType;
  /** Common MTU for all broder ports. */
  mtu: number;
  /** MD5 password or TCP-AO keychain encryption password in clear text. */
  password: string;
  /** Indicates that authentication is TCP-AO based (not Supported for Beta). */
  tcpAo: boolean;
  /** The anycast gateway MAC address for all fabrics in the Multisite. */
  sagMac: string;
  /** Member fabrics of the interconnect. */
  fabrics: DciFabric[];
  /** A list of interconnect VNI mappings. */
  vnis: DciVni[];
  /** The number of active candidate configurations of the DCI. */
  numCandidates: number;
  /** Overlay export policy identifier. Do not use; internal use only. */
  exportPolicyId: string;
  /** Overlay import policy identifier. Do not use; internal use only. */
  importPolicyId: string;
  /** A list of underlay BGP peers. Do not use; internal use only. */
  bgpPeers: BgpPeer[];
  /** A list of static routes. Do not use; internal use only. */
  staticRoutes: RouteInfo[];
}

/** BorderPort describes a border port of a node. */
export interface BorderPort {
  /** The name of the border port. */
  name: string;
  /** The IP address of the border port. */
  ipAddress: string;
  /** Indicates if border ports in in active state. */
  enabled: boolean;
}

/** BorderNode describes a border gateway node of a fabric. */
export interface BorderNode {
  /** The identifier of the node. */
  nodeId: string;
  /** The name of the node (readonly), */
  name: string;
  /** Indicates that node is in enabled state. */
  enabled: boolean;
  /** A list of ports to be used as border ports. */
  ports: BorderPort[];
}

/**
 * FabricMultisite describes the configurable properties of a
 * Multisite or DCI from fabric point of view. FabricMultisite
 * must be saved in the fabric context.
 */
export interface FabricMultisite {
  /**
   * The unique identifier of FabricMultisite. This identifier is same
   * as that of parent DciConfig object.
   */
  id: string;
  /** The user-defined name of DciConfig. FabricMultisite name is unique, and is case-insensitive. */
  name: string;
  /** A user-defined description of DciConfig. Description can be up to 2000 characters. */
  description: string;
  /** A set of user-defined labels for searching and locating objects. */
  labels: string[];
  /** A set of annotations to store user-defined data. */
  annotations: Annotation[];
  /** Indicates if FabricMultisite is enabled or not. */
  enabled: boolean;
  /**
   * Readonly revision metadata of the object. Metadata is not required
   * for object creation or modification.
   */
  metadata:
    | Metadata
    | undefined;
  /** The identifier of parent fabric. */
  fabricId: string;
  /** The identifier of parent DciConfig. */
  dciId: string;
  /** The candidate of DciConfig that user has reviewed and accepted. */
  candidateId: string;
  /**
   * The anycast gateway MAC address inherited from parent Multisite object.
   * This anycast MAC address will overwrite the fabric's anycast MAC address.
   */
  sagMac: string;
  /** A list of border nodes. */
  nodes: BorderNode[];
  /** A list of interconnect VNI mappings. */
  vnis: FabricVni[];
  /** A list of interconnect VRF mappings. */
  vrfs: FabricVrf[];
  /** A list of underlay BGP peers. */
  bgpPeers: BgpPeer[];
  /** A set of static routes when underlay is not BGP. */
  staticRoutes: RouteInfo[];
}

function createBaseFabricVni(): FabricVni {
  return { fabricId: "", vni: 0, name: "", enabled: false, normalizedVni: 0 };
}

export const FabricVni: MessageFns<FabricVni> = {
  encode(message: FabricVni, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.vni !== 0) {
      writer.uint32(16).uint32(message.vni);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.enabled !== false) {
      writer.uint32(32).bool(message.enabled);
    }
    if (message.normalizedVni !== 0) {
      writer.uint32(40).uint32(message.normalizedVni);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricVni {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricVni();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.normalizedVni = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricVni {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      normalizedVni: isSet(object.normalizedVni) ? globalThis.Number(object.normalizedVni) : 0,
    };
  },

  toJSON(message: FabricVni): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.normalizedVni !== 0) {
      obj.normalizedVni = Math.round(message.normalizedVni);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricVni>, I>>(base?: I): FabricVni {
    return FabricVni.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricVni>, I>>(object: I): FabricVni {
    const message = createBaseFabricVni();
    message.fabricId = object.fabricId ?? "";
    message.vni = object.vni ?? 0;
    message.name = object.name ?? "";
    message.enabled = object.enabled ?? false;
    message.normalizedVni = object.normalizedVni ?? 0;
    return message;
  },
};

function createBaseFabricSvi(): FabricSvi {
  return { vni: 0, enabled: false, normalizedVni: 0 };
}

export const FabricSvi: MessageFns<FabricSvi> = {
  encode(message: FabricSvi, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vni !== 0) {
      writer.uint32(8).uint32(message.vni);
    }
    if (message.enabled !== false) {
      writer.uint32(16).bool(message.enabled);
    }
    if (message.normalizedVni !== 0) {
      writer.uint32(24).uint32(message.normalizedVni);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricSvi {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricSvi();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.normalizedVni = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricSvi {
    return {
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      normalizedVni: isSet(object.normalizedVni) ? globalThis.Number(object.normalizedVni) : 0,
    };
  },

  toJSON(message: FabricSvi): unknown {
    const obj: any = {};
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.normalizedVni !== 0) {
      obj.normalizedVni = Math.round(message.normalizedVni);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricSvi>, I>>(base?: I): FabricSvi {
    return FabricSvi.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricSvi>, I>>(object: I): FabricSvi {
    const message = createBaseFabricSvi();
    message.vni = object.vni ?? 0;
    message.enabled = object.enabled ?? false;
    message.normalizedVni = object.normalizedVni ?? 0;
    return message;
  },
};

function createBaseBgpPolicyLink(): BgpPolicyLink {
  return { fabricId: "", exportPolicyId: "", importPolicyId: "" };
}

export const BgpPolicyLink: MessageFns<BgpPolicyLink> = {
  encode(message: BgpPolicyLink, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.exportPolicyId !== "") {
      writer.uint32(42).string(message.exportPolicyId);
    }
    if (message.importPolicyId !== "") {
      writer.uint32(50).string(message.importPolicyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpPolicyLink {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpPolicyLink();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.exportPolicyId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.importPolicyId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpPolicyLink {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      exportPolicyId: isSet(object.exportPolicyId) ? globalThis.String(object.exportPolicyId) : "",
      importPolicyId: isSet(object.importPolicyId) ? globalThis.String(object.importPolicyId) : "",
    };
  },

  toJSON(message: BgpPolicyLink): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.exportPolicyId !== "") {
      obj.exportPolicyId = message.exportPolicyId;
    }
    if (message.importPolicyId !== "") {
      obj.importPolicyId = message.importPolicyId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpPolicyLink>, I>>(base?: I): BgpPolicyLink {
    return BgpPolicyLink.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpPolicyLink>, I>>(object: I): BgpPolicyLink {
    const message = createBaseBgpPolicyLink();
    message.fabricId = object.fabricId ?? "";
    message.exportPolicyId = object.exportPolicyId ?? "";
    message.importPolicyId = object.importPolicyId ?? "";
    return message;
  },
};

function createBaseFabricVrf(): FabricVrf {
  return { fabricId: "", name: "", vrfVni: 0, enabled: false, normalizedVni: 0, svis: [], policies: [] };
}

export const FabricVrf: MessageFns<FabricVrf> = {
  encode(message: FabricVrf, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.vrfVni !== 0) {
      writer.uint32(24).uint32(message.vrfVni);
    }
    if (message.enabled !== false) {
      writer.uint32(32).bool(message.enabled);
    }
    if (message.normalizedVni !== 0) {
      writer.uint32(40).uint32(message.normalizedVni);
    }
    for (const v of message.svis) {
      FabricSvi.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.policies) {
      BgpPolicyLink.encode(v!, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricVrf {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricVrf();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.vrfVni = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.normalizedVni = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.svis.push(FabricSvi.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.policies.push(BgpPolicyLink.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricVrf {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      vrfVni: isSet(object.vrfVni) ? globalThis.Number(object.vrfVni) : 0,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      normalizedVni: isSet(object.normalizedVni) ? globalThis.Number(object.normalizedVni) : 0,
      svis: globalThis.Array.isArray(object?.svis) ? object.svis.map((e: any) => FabricSvi.fromJSON(e)) : [],
      policies: globalThis.Array.isArray(object?.policies)
        ? object.policies.map((e: any) => BgpPolicyLink.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FabricVrf): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.vrfVni !== 0) {
      obj.vrfVni = Math.round(message.vrfVni);
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.normalizedVni !== 0) {
      obj.normalizedVni = Math.round(message.normalizedVni);
    }
    if (message.svis?.length) {
      obj.svis = message.svis.map((e) => FabricSvi.toJSON(e));
    }
    if (message.policies?.length) {
      obj.policies = message.policies.map((e) => BgpPolicyLink.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricVrf>, I>>(base?: I): FabricVrf {
    return FabricVrf.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricVrf>, I>>(object: I): FabricVrf {
    const message = createBaseFabricVrf();
    message.fabricId = object.fabricId ?? "";
    message.name = object.name ?? "";
    message.vrfVni = object.vrfVni ?? 0;
    message.enabled = object.enabled ?? false;
    message.normalizedVni = object.normalizedVni ?? 0;
    message.svis = object.svis?.map((e) => FabricSvi.fromPartial(e)) || [];
    message.policies = object.policies?.map((e) => BgpPolicyLink.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFabricLink(): FabricLink {
  return { fabricId: "", name: "" };
}

export const FabricLink: MessageFns<FabricLink> = {
  encode(message: FabricLink, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricLink {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricLink();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricLink {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: FabricLink): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricLink>, I>>(base?: I): FabricLink {
    return FabricLink.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricLink>, I>>(object: I): FabricLink {
    const message = createBaseFabricLink();
    message.fabricId = object.fabricId ?? "";
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseMultisiteSvi(): MultisiteSvi {
  return { vni: 0, name: "", enabled: false };
}

export const MultisiteSvi: MessageFns<MultisiteSvi> = {
  encode(message: MultisiteSvi, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vni !== 0) {
      writer.uint32(8).uint32(message.vni);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.enabled !== false) {
      writer.uint32(24).bool(message.enabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MultisiteSvi {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultisiteSvi();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MultisiteSvi {
    return {
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
    };
  },

  toJSON(message: MultisiteSvi): unknown {
    const obj: any = {};
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MultisiteSvi>, I>>(base?: I): MultisiteSvi {
    return MultisiteSvi.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MultisiteSvi>, I>>(object: I): MultisiteSvi {
    const message = createBaseMultisiteSvi();
    message.vni = object.vni ?? 0;
    message.name = object.name ?? "";
    message.enabled = object.enabled ?? false;
    return message;
  },
};

function createBaseDciVni(): DciVni {
  return { vni: 0, name: "", description: "", enabled: false, isL3: false, fabrics: [], svis: [], vnis: [], vrfs: [] };
}

export const DciVni: MessageFns<DciVni> = {
  encode(message: DciVni, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vni !== 0) {
      writer.uint32(16).uint32(message.vni);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.enabled !== false) {
      writer.uint32(40).bool(message.enabled);
    }
    if (message.isL3 !== false) {
      writer.uint32(48).bool(message.isL3);
    }
    for (const v of message.fabrics) {
      FabricLink.encode(v!, writer.uint32(66).fork()).join();
    }
    for (const v of message.svis) {
      MultisiteSvi.encode(v!, writer.uint32(74).fork()).join();
    }
    for (const v of message.vnis) {
      FabricVni.encode(v!, writer.uint32(82).fork()).join();
    }
    for (const v of message.vrfs) {
      FabricVrf.encode(v!, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DciVni {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDciVni();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isL3 = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.fabrics.push(FabricLink.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.svis.push(MultisiteSvi.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.vnis.push(FabricVni.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.vrfs.push(FabricVrf.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DciVni {
    return {
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      isL3: isSet(object.isL3) ? globalThis.Boolean(object.isL3) : false,
      fabrics: globalThis.Array.isArray(object?.fabrics) ? object.fabrics.map((e: any) => FabricLink.fromJSON(e)) : [],
      svis: globalThis.Array.isArray(object?.svis) ? object.svis.map((e: any) => MultisiteSvi.fromJSON(e)) : [],
      vnis: globalThis.Array.isArray(object?.vnis) ? object.vnis.map((e: any) => FabricVni.fromJSON(e)) : [],
      vrfs: globalThis.Array.isArray(object?.vrfs) ? object.vrfs.map((e: any) => FabricVrf.fromJSON(e)) : [],
    };
  },

  toJSON(message: DciVni): unknown {
    const obj: any = {};
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.isL3 !== false) {
      obj.isL3 = message.isL3;
    }
    if (message.fabrics?.length) {
      obj.fabrics = message.fabrics.map((e) => FabricLink.toJSON(e));
    }
    if (message.svis?.length) {
      obj.svis = message.svis.map((e) => MultisiteSvi.toJSON(e));
    }
    if (message.vnis?.length) {
      obj.vnis = message.vnis.map((e) => FabricVni.toJSON(e));
    }
    if (message.vrfs?.length) {
      obj.vrfs = message.vrfs.map((e) => FabricVrf.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DciVni>, I>>(base?: I): DciVni {
    return DciVni.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DciVni>, I>>(object: I): DciVni {
    const message = createBaseDciVni();
    message.vni = object.vni ?? 0;
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.enabled = object.enabled ?? false;
    message.isL3 = object.isL3 ?? false;
    message.fabrics = object.fabrics?.map((e) => FabricLink.fromPartial(e)) || [];
    message.svis = object.svis?.map((e) => MultisiteSvi.fromPartial(e)) || [];
    message.vnis = object.vnis?.map((e) => FabricVni.fromPartial(e)) || [];
    message.vrfs = object.vrfs?.map((e) => FabricVrf.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDciPort(): DciPort {
  return { name: "", enabled: false, mtu: 0, ipAddress: "" };
}

export const DciPort: MessageFns<DciPort> = {
  encode(message: DciPort, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.enabled !== false) {
      writer.uint32(16).bool(message.enabled);
    }
    if (message.mtu !== 0) {
      writer.uint32(40).uint32(message.mtu);
    }
    if (message.ipAddress !== "") {
      writer.uint32(50).string(message.ipAddress);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DciPort {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDciPort();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.mtu = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ipAddress = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DciPort {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      mtu: isSet(object.mtu) ? globalThis.Number(object.mtu) : 0,
      ipAddress: isSet(object.ipAddress) ? globalThis.String(object.ipAddress) : "",
    };
  },

  toJSON(message: DciPort): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.mtu !== 0) {
      obj.mtu = Math.round(message.mtu);
    }
    if (message.ipAddress !== "") {
      obj.ipAddress = message.ipAddress;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DciPort>, I>>(base?: I): DciPort {
    return DciPort.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DciPort>, I>>(object: I): DciPort {
    const message = createBaseDciPort();
    message.name = object.name ?? "";
    message.enabled = object.enabled ?? false;
    message.mtu = object.mtu ?? 0;
    message.ipAddress = object.ipAddress ?? "";
    return message;
  },
};

function createBaseDciNode(): DciNode {
  return { nodeId: "", name: "", description: "", enabled: false, primaryIp: "", loopbackIp: "", ports: [] };
}

export const DciNode: MessageFns<DciNode> = {
  encode(message: DciNode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.enabled !== false) {
      writer.uint32(40).bool(message.enabled);
    }
    if (message.primaryIp !== "") {
      writer.uint32(82).string(message.primaryIp);
    }
    if (message.loopbackIp !== "") {
      writer.uint32(90).string(message.loopbackIp);
    }
    for (const v of message.ports) {
      DciPort.encode(v!, writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DciNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDciNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.primaryIp = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.loopbackIp = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.ports.push(DciPort.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DciNode {
    return {
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      primaryIp: isSet(object.primaryIp) ? globalThis.String(object.primaryIp) : "",
      loopbackIp: isSet(object.loopbackIp) ? globalThis.String(object.loopbackIp) : "",
      ports: globalThis.Array.isArray(object?.ports) ? object.ports.map((e: any) => DciPort.fromJSON(e)) : [],
    };
  },

  toJSON(message: DciNode): unknown {
    const obj: any = {};
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.primaryIp !== "") {
      obj.primaryIp = message.primaryIp;
    }
    if (message.loopbackIp !== "") {
      obj.loopbackIp = message.loopbackIp;
    }
    if (message.ports?.length) {
      obj.ports = message.ports.map((e) => DciPort.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DciNode>, I>>(base?: I): DciNode {
    return DciNode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DciNode>, I>>(object: I): DciNode {
    const message = createBaseDciNode();
    message.nodeId = object.nodeId ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.enabled = object.enabled ?? false;
    message.primaryIp = object.primaryIp ?? "";
    message.loopbackIp = object.loopbackIp ?? "";
    message.ports = object.ports?.map((e) => DciPort.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDciFabric(): DciFabric {
  return {
    fabricId: "",
    name: "",
    description: "",
    enabled: false,
    email: "",
    virtualIp: "",
    asn: 0,
    fabricIp: "",
    accepted: false,
    acceptedAt: undefined,
    commitId: "0",
    nodes: [],
  };
}

export const DciFabric: MessageFns<DciFabric> = {
  encode(message: DciFabric, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.enabled !== false) {
      writer.uint32(40).bool(message.enabled);
    }
    if (message.email !== "") {
      writer.uint32(50).string(message.email);
    }
    if (message.virtualIp !== "") {
      writer.uint32(82).string(message.virtualIp);
    }
    if (message.asn !== 0) {
      writer.uint32(88).uint32(message.asn);
    }
    if (message.fabricIp !== "") {
      writer.uint32(98).string(message.fabricIp);
    }
    if (message.accepted !== false) {
      writer.uint32(104).bool(message.accepted);
    }
    if (message.acceptedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.acceptedAt), writer.uint32(114).fork()).join();
    }
    if (message.commitId !== "0") {
      writer.uint32(128).int64(message.commitId);
    }
    for (const v of message.nodes) {
      DciNode.encode(v!, writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DciFabric {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDciFabric();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.virtualIp = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.asn = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.fabricIp = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.accepted = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.acceptedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.commitId = reader.int64().toString();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.nodes.push(DciNode.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DciFabric {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      virtualIp: isSet(object.virtualIp) ? globalThis.String(object.virtualIp) : "",
      asn: isSet(object.asn) ? globalThis.Number(object.asn) : 0,
      fabricIp: isSet(object.fabricIp) ? globalThis.String(object.fabricIp) : "",
      accepted: isSet(object.accepted) ? globalThis.Boolean(object.accepted) : false,
      acceptedAt: isSet(object.acceptedAt) ? fromJsonTimestamp(object.acceptedAt) : undefined,
      commitId: isSet(object.commitId) ? globalThis.String(object.commitId) : "0",
      nodes: globalThis.Array.isArray(object?.nodes) ? object.nodes.map((e: any) => DciNode.fromJSON(e)) : [],
    };
  },

  toJSON(message: DciFabric): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.virtualIp !== "") {
      obj.virtualIp = message.virtualIp;
    }
    if (message.asn !== 0) {
      obj.asn = Math.round(message.asn);
    }
    if (message.fabricIp !== "") {
      obj.fabricIp = message.fabricIp;
    }
    if (message.accepted !== false) {
      obj.accepted = message.accepted;
    }
    if (message.acceptedAt !== undefined) {
      obj.acceptedAt = message.acceptedAt.toISOString();
    }
    if (message.commitId !== "0") {
      obj.commitId = message.commitId;
    }
    if (message.nodes?.length) {
      obj.nodes = message.nodes.map((e) => DciNode.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DciFabric>, I>>(base?: I): DciFabric {
    return DciFabric.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DciFabric>, I>>(object: I): DciFabric {
    const message = createBaseDciFabric();
    message.fabricId = object.fabricId ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.enabled = object.enabled ?? false;
    message.email = object.email ?? "";
    message.virtualIp = object.virtualIp ?? "";
    message.asn = object.asn ?? 0;
    message.fabricIp = object.fabricIp ?? "";
    message.accepted = object.accepted ?? false;
    message.acceptedAt = object.acceptedAt ?? undefined;
    message.commitId = object.commitId ?? "0";
    message.nodes = object.nodes?.map((e) => DciNode.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDciConfig(): DciConfig {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    candidateId: "0",
    type: 0,
    mtu: 0,
    password: "",
    tcpAo: false,
    sagMac: "",
    fabrics: [],
    vnis: [],
    numCandidates: 0,
    exportPolicyId: "",
    importPolicyId: "",
    bgpPeers: [],
    staticRoutes: [],
  };
}

export const DciConfig: MessageFns<DciConfig> = {
  encode(message: DciConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.candidateId !== "0") {
      writer.uint32(64).int64(message.candidateId);
    }
    if (message.type !== 0) {
      writer.uint32(80).int32(message.type);
    }
    if (message.mtu !== 0) {
      writer.uint32(88).uint32(message.mtu);
    }
    if (message.password !== "") {
      writer.uint32(98).string(message.password);
    }
    if (message.tcpAo !== false) {
      writer.uint32(104).bool(message.tcpAo);
    }
    if (message.sagMac !== "") {
      writer.uint32(114).string(message.sagMac);
    }
    for (const v of message.fabrics) {
      DciFabric.encode(v!, writer.uint32(162).fork()).join();
    }
    for (const v of message.vnis) {
      DciVni.encode(v!, writer.uint32(170).fork()).join();
    }
    if (message.numCandidates !== 0) {
      writer.uint32(184).uint32(message.numCandidates);
    }
    if (message.exportPolicyId !== "") {
      writer.uint32(226).string(message.exportPolicyId);
    }
    if (message.importPolicyId !== "") {
      writer.uint32(234).string(message.importPolicyId);
    }
    for (const v of message.bgpPeers) {
      BgpPeer.encode(v!, writer.uint32(242).fork()).join();
    }
    for (const v of message.staticRoutes) {
      RouteInfo.encode(v!, writer.uint32(250).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DciConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDciConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.candidateId = reader.int64().toString();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.mtu = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.password = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.tcpAo = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.sagMac = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.fabrics.push(DciFabric.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.vnis.push(DciVni.decode(reader, reader.uint32()));
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.numCandidates = reader.uint32();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.exportPolicyId = reader.string();
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.importPolicyId = reader.string();
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.bgpPeers.push(BgpPeer.decode(reader, reader.uint32()));
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.staticRoutes.push(RouteInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DciConfig {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      candidateId: isSet(object.candidateId) ? globalThis.String(object.candidateId) : "0",
      type: isSet(object.type) ? dciTypeFromJSON(object.type) : 0,
      mtu: isSet(object.mtu) ? globalThis.Number(object.mtu) : 0,
      password: isSet(object.password) ? globalThis.String(object.password) : "",
      tcpAo: isSet(object.tcpAo) ? globalThis.Boolean(object.tcpAo) : false,
      sagMac: isSet(object.sagMac) ? globalThis.String(object.sagMac) : "",
      fabrics: globalThis.Array.isArray(object?.fabrics) ? object.fabrics.map((e: any) => DciFabric.fromJSON(e)) : [],
      vnis: globalThis.Array.isArray(object?.vnis) ? object.vnis.map((e: any) => DciVni.fromJSON(e)) : [],
      numCandidates: isSet(object.numCandidates) ? globalThis.Number(object.numCandidates) : 0,
      exportPolicyId: isSet(object.exportPolicyId) ? globalThis.String(object.exportPolicyId) : "",
      importPolicyId: isSet(object.importPolicyId) ? globalThis.String(object.importPolicyId) : "",
      bgpPeers: globalThis.Array.isArray(object?.bgpPeers) ? object.bgpPeers.map((e: any) => BgpPeer.fromJSON(e)) : [],
      staticRoutes: globalThis.Array.isArray(object?.staticRoutes)
        ? object.staticRoutes.map((e: any) => RouteInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DciConfig): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.candidateId !== "0") {
      obj.candidateId = message.candidateId;
    }
    if (message.type !== 0) {
      obj.type = dciTypeToJSON(message.type);
    }
    if (message.mtu !== 0) {
      obj.mtu = Math.round(message.mtu);
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    if (message.tcpAo !== false) {
      obj.tcpAo = message.tcpAo;
    }
    if (message.sagMac !== "") {
      obj.sagMac = message.sagMac;
    }
    if (message.fabrics?.length) {
      obj.fabrics = message.fabrics.map((e) => DciFabric.toJSON(e));
    }
    if (message.vnis?.length) {
      obj.vnis = message.vnis.map((e) => DciVni.toJSON(e));
    }
    if (message.numCandidates !== 0) {
      obj.numCandidates = Math.round(message.numCandidates);
    }
    if (message.exportPolicyId !== "") {
      obj.exportPolicyId = message.exportPolicyId;
    }
    if (message.importPolicyId !== "") {
      obj.importPolicyId = message.importPolicyId;
    }
    if (message.bgpPeers?.length) {
      obj.bgpPeers = message.bgpPeers.map((e) => BgpPeer.toJSON(e));
    }
    if (message.staticRoutes?.length) {
      obj.staticRoutes = message.staticRoutes.map((e) => RouteInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DciConfig>, I>>(base?: I): DciConfig {
    return DciConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DciConfig>, I>>(object: I): DciConfig {
    const message = createBaseDciConfig();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.candidateId = object.candidateId ?? "0";
    message.type = object.type ?? 0;
    message.mtu = object.mtu ?? 0;
    message.password = object.password ?? "";
    message.tcpAo = object.tcpAo ?? false;
    message.sagMac = object.sagMac ?? "";
    message.fabrics = object.fabrics?.map((e) => DciFabric.fromPartial(e)) || [];
    message.vnis = object.vnis?.map((e) => DciVni.fromPartial(e)) || [];
    message.numCandidates = object.numCandidates ?? 0;
    message.exportPolicyId = object.exportPolicyId ?? "";
    message.importPolicyId = object.importPolicyId ?? "";
    message.bgpPeers = object.bgpPeers?.map((e) => BgpPeer.fromPartial(e)) || [];
    message.staticRoutes = object.staticRoutes?.map((e) => RouteInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBorderPort(): BorderPort {
  return { name: "", ipAddress: "", enabled: false };
}

export const BorderPort: MessageFns<BorderPort> = {
  encode(message: BorderPort, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.ipAddress !== "") {
      writer.uint32(18).string(message.ipAddress);
    }
    if (message.enabled !== false) {
      writer.uint32(24).bool(message.enabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BorderPort {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBorderPort();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ipAddress = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BorderPort {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      ipAddress: isSet(object.ipAddress) ? globalThis.String(object.ipAddress) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
    };
  },

  toJSON(message: BorderPort): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.ipAddress !== "") {
      obj.ipAddress = message.ipAddress;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BorderPort>, I>>(base?: I): BorderPort {
    return BorderPort.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BorderPort>, I>>(object: I): BorderPort {
    const message = createBaseBorderPort();
    message.name = object.name ?? "";
    message.ipAddress = object.ipAddress ?? "";
    message.enabled = object.enabled ?? false;
    return message;
  },
};

function createBaseBorderNode(): BorderNode {
  return { nodeId: "", name: "", enabled: false, ports: [] };
}

export const BorderNode: MessageFns<BorderNode> = {
  encode(message: BorderNode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeId !== "") {
      writer.uint32(10).string(message.nodeId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.enabled !== false) {
      writer.uint32(24).bool(message.enabled);
    }
    for (const v of message.ports) {
      BorderPort.encode(v!, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BorderNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBorderNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.ports.push(BorderPort.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BorderNode {
    return {
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      ports: globalThis.Array.isArray(object?.ports) ? object.ports.map((e: any) => BorderPort.fromJSON(e)) : [],
    };
  },

  toJSON(message: BorderNode): unknown {
    const obj: any = {};
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.ports?.length) {
      obj.ports = message.ports.map((e) => BorderPort.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BorderNode>, I>>(base?: I): BorderNode {
    return BorderNode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BorderNode>, I>>(object: I): BorderNode {
    const message = createBaseBorderNode();
    message.nodeId = object.nodeId ?? "";
    message.name = object.name ?? "";
    message.enabled = object.enabled ?? false;
    message.ports = object.ports?.map((e) => BorderPort.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFabricMultisite(): FabricMultisite {
  return {
    id: "",
    name: "",
    description: "",
    labels: [],
    annotations: [],
    enabled: false,
    metadata: undefined,
    fabricId: "",
    dciId: "",
    candidateId: "0",
    sagMac: "",
    nodes: [],
    vnis: [],
    vrfs: [],
    bgpPeers: [],
    staticRoutes: [],
  };
}

export const FabricMultisite: MessageFns<FabricMultisite> = {
  encode(message: FabricMultisite, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.labels) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(58).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(82).string(message.fabricId);
    }
    if (message.dciId !== "") {
      writer.uint32(90).string(message.dciId);
    }
    if (message.candidateId !== "0") {
      writer.uint32(96).int64(message.candidateId);
    }
    if (message.sagMac !== "") {
      writer.uint32(114).string(message.sagMac);
    }
    for (const v of message.nodes) {
      BorderNode.encode(v!, writer.uint32(122).fork()).join();
    }
    for (const v of message.vnis) {
      FabricVni.encode(v!, writer.uint32(130).fork()).join();
    }
    for (const v of message.vrfs) {
      FabricVrf.encode(v!, writer.uint32(138).fork()).join();
    }
    for (const v of message.bgpPeers) {
      BgpPeer.encode(v!, writer.uint32(146).fork()).join();
    }
    for (const v of message.staticRoutes) {
      RouteInfo.encode(v!, writer.uint32(154).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricMultisite {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricMultisite();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.dciId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.candidateId = reader.int64().toString();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.sagMac = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.nodes.push(BorderNode.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.vnis.push(FabricVni.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.vrfs.push(FabricVrf.decode(reader, reader.uint32()));
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.bgpPeers.push(BgpPeer.decode(reader, reader.uint32()));
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.staticRoutes.push(RouteInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricMultisite {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      dciId: isSet(object.dciId) ? globalThis.String(object.dciId) : "",
      candidateId: isSet(object.candidateId) ? globalThis.String(object.candidateId) : "0",
      sagMac: isSet(object.sagMac) ? globalThis.String(object.sagMac) : "",
      nodes: globalThis.Array.isArray(object?.nodes) ? object.nodes.map((e: any) => BorderNode.fromJSON(e)) : [],
      vnis: globalThis.Array.isArray(object?.vnis) ? object.vnis.map((e: any) => FabricVni.fromJSON(e)) : [],
      vrfs: globalThis.Array.isArray(object?.vrfs) ? object.vrfs.map((e: any) => FabricVrf.fromJSON(e)) : [],
      bgpPeers: globalThis.Array.isArray(object?.bgpPeers) ? object.bgpPeers.map((e: any) => BgpPeer.fromJSON(e)) : [],
      staticRoutes: globalThis.Array.isArray(object?.staticRoutes)
        ? object.staticRoutes.map((e: any) => RouteInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FabricMultisite): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.dciId !== "") {
      obj.dciId = message.dciId;
    }
    if (message.candidateId !== "0") {
      obj.candidateId = message.candidateId;
    }
    if (message.sagMac !== "") {
      obj.sagMac = message.sagMac;
    }
    if (message.nodes?.length) {
      obj.nodes = message.nodes.map((e) => BorderNode.toJSON(e));
    }
    if (message.vnis?.length) {
      obj.vnis = message.vnis.map((e) => FabricVni.toJSON(e));
    }
    if (message.vrfs?.length) {
      obj.vrfs = message.vrfs.map((e) => FabricVrf.toJSON(e));
    }
    if (message.bgpPeers?.length) {
      obj.bgpPeers = message.bgpPeers.map((e) => BgpPeer.toJSON(e));
    }
    if (message.staticRoutes?.length) {
      obj.staticRoutes = message.staticRoutes.map((e) => RouteInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricMultisite>, I>>(base?: I): FabricMultisite {
    return FabricMultisite.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricMultisite>, I>>(object: I): FabricMultisite {
    const message = createBaseFabricMultisite();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.enabled = object.enabled ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.fabricId = object.fabricId ?? "";
    message.dciId = object.dciId ?? "";
    message.candidateId = object.candidateId ?? "0";
    message.sagMac = object.sagMac ?? "";
    message.nodes = object.nodes?.map((e) => BorderNode.fromPartial(e)) || [];
    message.vnis = object.vnis?.map((e) => FabricVni.fromPartial(e)) || [];
    message.vrfs = object.vrfs?.map((e) => FabricVrf.fromPartial(e)) || [];
    message.bgpPeers = object.bgpPeers?.map((e) => BgpPeer.fromPartial(e)) || [];
    message.staticRoutes = object.staticRoutes?.map((e) => RouteInfo.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
